import React from "react";
import { Outlet } from "react-router-dom";
import { BottomNav } from "../components/BottomNav";
import { DevCredit } from "../components/DevCredit";

export default function AppLayout() {
  return (
    <div className="min-h-screen bg-[#121212] text-white">
      <Outlet />
      <DevCredit className="pb-24 pt-2" />
      <BottomNav />
    </div>
  );
}
